export default "__VITE_ASSET__CsLfI6Rr__"